import { render, staticRenderFns } from "./fork_info.vue?vue&type=template&id=13a3cf26&vue3"
import script from "./fork_info.vue?vue&type=script&lang=js&vue3"
export * from "./fork_info.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports